module.exports = {"confirmation_page_main":{"componentName":"ConfirmationPageMain"}}